export default "__VITE_ASSET__f677ab7a__"